import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=131c9728&"
import script from "./PageFooter.vue?vue&type=script&lang=ts&"
export * from "./PageFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports